import { createAction } from 'redux-actions';

import { CHECKING_PACKAGE, FINISH_CHECKING_PACKAGE, UPDATE_RECEIVE_QUANTITY } from './constants';

export const successCheckingPackage = createAction(CHECKING_PACKAGE.SUCCESS);
export const failedCheckingPackage = createAction(CHECKING_PACKAGE.FAILED);
export const successUpdateReceiveQuantity = createAction(UPDATE_RECEIVE_QUANTITY.SUCCESS);
export const finishCheckingPackage = createAction(FINISH_CHECKING_PACKAGE.REQUEST);
